(function () {
  // Tier color definitions (color = bar + text + stat; bg = badge background)
  var TIERS = {
    low:    { color: '#d9543c', bg: '#fef0eb' },  // red-orange
    medium: { color: '#c8961e', bg: '#fdf5e8' },  // golden amber
    high:   { color: '#52a652', bg: '#edf7ed' }   // green
  };
  var TIERS_UVA = {
    low:    { color: '#d9543c', bg: '#fef0eb' },  // red-orange
    medium: { color: '#c8961e', bg: '#fdf5e8' },  // golden amber
    high:   {color: 'rgb(101, 163, 13)', bg: 'rgb(101 163 13 / 10%)'},
    veryhigh:  { color: '#52a652', bg: '#edf7ed' }   // green
  };

  // SPF levels — tier drives color, label/desc are the displayed text
  // Dermatologist threshold: SPF 30 = minimum "High Protection"
  var SPF_LEVELS = [
    {
      max: 29,
      tier: 'low',
      label: 'Moderate Protection',
      desc: 'Provides basic UVB protection but may be insufficient for prolonged outdoor exposure.'
    },
    {
      max: 49,
      tier: 'medium',
      label: 'High Protection',
      desc: 'Recommended for everyday use. Provides strong UVB protection for most outdoor activities.'
    },
    {
      max: Infinity,
      tier: 'high',
      label: 'Very High Protection',
      desc: 'Ideal for extended outdoor exposure, especially during sports, beach vacations, hiking or high UV environments.'
    }
  ];

  // PA rating data — content matches Figma design
  var PA_DATA = {
    'PA+': {
      progress: 25,
      TIERS_UVA: 'low',
      level: 'Basic Protection',
      desc: 'Some protection against UVA rays.',
      blocked: '50-80%'
    },
    'PA++': {
      progress: 50,
      TIERS_UVA: 'medium',
      level: 'Good Protection',
      desc: 'Moderate protection against UVA rays.',
      blocked: '80-90%'
    },
    'PA+++': {
      progress: 75,
      TIERS_UVA: 'high',
      level: 'Very Good Protection',
      desc: 'High protection against UVA rays.',
      blocked: '90-95%'
    },
    'PA++++': {
      progress: 100,
      TIERS_UVA: 'veryhigh',
      level: 'Excellent Protection',
      desc: 'Maximum protection against UVA rays.',
      blocked: '95%+'
    }
  };

  var SPF_MIN = 1;
  var SPF_MAX = 100;
  var spfValue = 30;
  var selectedPA = 'PA++';

  function getSpfLevel(spf) {
    for (var i = 0; i < SPF_LEVELS.length; i++) {
      if (spf <= SPF_LEVELS[i].max) return SPF_LEVELS[i];
    }
    return SPF_LEVELS[SPF_LEVELS.length - 1];
  }

  // Formula: (1 − 1/SPF) × 100
  function calcUvbBlocked(spf) {
    if (spf <= 0) return '0.0';
    return ((1 - 1 / spf) * 100).toFixed(2);
  }

  function applyTier(cardId, tier, tiersObj) {
    var card = document.getElementById(cardId);
    var colors = (tiersObj || TIERS)[tier];
    card.style.setProperty('--meter-color', colors.color);
    card.style.setProperty('--meter-bg', colors.bg);
  }

  function updateSPFUI() {
    var level = getSpfLevel(spfValue);
    var uvbBlocked = calcUvbBlocked(spfValue);
    var progress = Math.min((spfValue / SPF_MAX) * 100, 100);

    document.getElementById('spfm-spf-value').textContent = spfValue;
    document.getElementById('spfm-spf-bar').style.width = progress + '%';
    document.getElementById('spfm-spf-level').textContent = level.label;
    document.getElementById('spfm-spf-desc').textContent = level.desc;
    document.getElementById('spfm-uvb-blocked').textContent = uvbBlocked + '%';

    applyTier('spfm-uvb-card', level.tier);

    document.getElementById('spfm-decrease').disabled = spfValue <= SPF_MIN;
    document.getElementById('spfm-increase').disabled = spfValue >= SPF_MAX;
  }

  function updatePAUI() {
    var data = PA_DATA[selectedPA];

    document.getElementById('spfm-pa-bar').style.width = data.progress + '%';
    document.getElementById('spfm-pa-level').textContent = data.level;
    document.getElementById('spfm-pa-desc').textContent = data.desc;
    document.getElementById('spfm-uva-blocked').textContent = data.blocked;

    applyTier('spfm-uva-card', data.TIERS_UVA, TIERS_UVA);

    var buttons = document.querySelectorAll('.spfm-pa-btn');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].classList.toggle('spfm-pa-active', buttons[i].getAttribute('data-pa') === selectedPA);
    }
  }

  // SPF counter click events
  document.getElementById('spfm-decrease').addEventListener('click', function () {
    if (spfValue > SPF_MIN) {
      spfValue--;
      updateSPFUI();
    }
  });

  document.getElementById('spfm-increase').addEventListener('click', function () {
    if (spfValue < SPF_MAX) {
      spfValue++;
      updateSPFUI();
    }
  });

  // Hold-to-repeat for +/- buttons
  var holdTimer = null;
  var holdInterval = null;

  function startHold(direction) {
    holdTimer = setTimeout(function () {
      holdInterval = setInterval(function () {
        if (direction === 'up' && spfValue < SPF_MAX) {
          spfValue++;
          updateSPFUI();
        } else if (direction === 'down' && spfValue > SPF_MIN) {
          spfValue--;
          updateSPFUI();
        } else {
          stopHold();
        }
      }, 80);
    }, 400);
  }

  function stopHold() {
    clearTimeout(holdTimer);
    clearInterval(holdInterval);
    holdTimer = null;
    holdInterval = null;
  }

  document.getElementById('spfm-increase').addEventListener('mousedown', function () { startHold('up'); });
  document.getElementById('spfm-decrease').addEventListener('mousedown', function () { startHold('down'); });
  document.addEventListener('mouseup', stopHold);
  document.getElementById('spfm-increase').addEventListener('touchstart', function () { startHold('up'); }, { passive: true });
  document.getElementById('spfm-decrease').addEventListener('touchstart', function () { startHold('down'); }, { passive: true });
  document.addEventListener('touchend', stopHold);

  // PA button events
  var paButtons = document.querySelectorAll('.spfm-pa-btn');
  for (var i = 0; i < paButtons.length; i++) {
    paButtons[i].addEventListener('click', function () {
      selectedPA = this.getAttribute('data-pa');
      updatePAUI();
    });
  }

  // Initialize
  updateSPFUI();
  updatePAUI();
})();
